const TextingSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Visual */}
          <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-3xl p-8 shadow-2xl">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
              {/* Phone Header */}
              <div className="bg-gradient-to-r from-pink-500 to-purple-500 px-6 py-4 text-white">
                <div className="flex items-center gap-3">
                  <img 
                    src="https://static.readdy.ai/image/f188085399ab07ac2c79984c802b33af/d7137dec17d438e55dac1175e416585f.png" 
                    alt="Genie" 
                    className="w-10 h-10"
                  />
                  <div>
                    <div className="font-bold">ReceptionGenie</div>
                    <div className="text-xs opacity-90">Online</div>
                  </div>
                </div>
              </div>
              
              {/* Messages */}
              <div className="p-6 space-y-4 bg-gray-50 max-h-96 overflow-y-auto">
                <div className="flex justify-start">
                  <div className="bg-white rounded-2xl rounded-tl-none p-3 shadow-sm max-w-xs">
                    <p className="text-sm text-gray-800">Hi! Do you have availability this week?</p>
                    <div className="text-xs text-gray-400 mt-1">10:23 AM</div>
                  </div>
                </div>
                
                <div className="flex justify-end">
                  <div className="bg-gradient-to-r from-pink-500 to-purple-500 rounded-2xl rounded-tr-none p-3 shadow-sm max-w-xs">
                    <p className="text-sm text-white">Hello! Yes, I'd be happy to help. We have several openings this week. What day works best for you?</p>
                    <div className="text-xs text-pink-100 mt-1">10:23 AM</div>
                  </div>
                </div>
                
                <div className="flex justify-start">
                  <div className="bg-white rounded-2xl rounded-tl-none p-3 shadow-sm max-w-xs">
                    <p className="text-sm text-gray-800">Thursday afternoon would be perfect</p>
                    <div className="text-xs text-gray-400 mt-1">10:24 AM</div>
                  </div>
                </div>
                
                <div className="flex justify-end">
                  <div className="bg-gradient-to-r from-pink-500 to-purple-500 rounded-2xl rounded-tr-none p-3 shadow-sm max-w-xs">
                    <p className="text-sm text-white">Great! I have 2:00 PM and 4:00 PM available on Thursday. Which time works better for you?</p>
                    <div className="text-xs text-pink-100 mt-1">10:24 AM</div>
                  </div>
                </div>
                
                <div className="flex justify-start">
                  <div className="bg-white rounded-2xl rounded-tl-none p-3 shadow-sm max-w-xs">
                    <p className="text-sm text-gray-800">2:00 PM is perfect!</p>
                    <div className="text-xs text-gray-400 mt-1">10:25 AM</div>
                  </div>
                </div>
                
                <div className="flex justify-end">
                  <div className="bg-gradient-to-r from-pink-500 to-purple-500 rounded-2xl rounded-tr-none p-3 shadow-sm max-w-xs">
                    <p className="text-sm text-white">Excellent! You're all booked for Thursday at 2:00 PM. I've sent you a confirmation text with all the details. Looking forward to seeing you! 😊</p>
                    <div className="text-xs text-pink-100 mt-1">10:25 AM</div>
                  </div>
                </div>
              </div>
              
              {/* Input Area */}
              <div className="bg-white border-t border-gray-200 px-4 py-3">
                <div className="flex items-center gap-2">
                  <input 
                    type="text" 
                    placeholder="Type a message..." 
                    className="flex-1 px-4 py-2 bg-gray-100 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-pink-500"
                    disabled
                  />
                  <button className="w-10 h-10 bg-pink-500 rounded-full flex items-center justify-center cursor-pointer">
                    <i className="ri-send-plane-fill text-white"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          {/* Right Content */}
          <div className="space-y-8">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
              Texting With Your Customers Made Easy
            </h2>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              ReceptionGenie's conversational AI lets it text back and forth with customers naturally, so you don't have to worry about responding to every message.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-chat-smile-3-line text-blue-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2">Natural Conversations</h3>
                  <p className="text-gray-600">Genie chats naturally with customers, understanding context and responding appropriately.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-flashlight-line text-purple-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2">Instant Responses</h3>
                  <p className="text-gray-600">Customers get immediate replies, even outside business hours.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-pink-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-notification-badge-line text-pink-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2">You Stay Informed</h3>
                  <p className="text-gray-600">Get real-time notifications for new messages and important conversations.</p>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-6">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <i className="ri-check-double-line text-green-600 text-2xl"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900">86% Response Rate</div>
                  <div className="text-sm text-gray-600">Customers love the instant replies</div>
                </div>
              </div>
              <div className="h-2 bg-white rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-green-400 to-blue-500 rounded-full" style={{ width: '86%' }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TextingSection;